import moment from "moment";
import { clone, getBase64ImageWithHeader } from "../../utils";

export function castInterventionFromDb(intervention) {
    intervention.date_planned_start = moment.utc(intervention.date_planned_start);
    return intervention;
}

export function adaptInterventionForMyOpen(intervention) {
    let newIntervention = clone(intervention);
    newIntervention.date_planned_start = moment(
        moment.utc(newIntervention.date_planned_start, "YYYY-MM-DD HH:mm:ss").local()
    );

    if (!newIntervention.mobile_id && !newIntervention.id) {
        console.error("Cet OT n'a ni mobile_id ni id OpenERP ce qui n'est pas possible");
        return;
    }

    if (!newIntervention.mobile_id && newIntervention.id) newIntervention.mobile_id = newIntervention.id.toString();

    if (newIntervention.state === "performed" && !newIntervention.internalState)
        newIntervention.internalState = "paused";

    newIntervention.report_block_ids = adaptBlocsForMyOpen(newIntervention.report_block_ids);

    return newIntervention;
}

export function adaptBlocsForMyOpen(blocs) {
    let newBlocs = [];

    blocs.forEach((b) => {
        let newBloc = clone(b);
        newBloc.field_ids = adaptFieldsForMyOpen(newBloc.field_ids);
        newBlocs.push(newBloc);
    });

    return newBlocs;
}

export function adaptFieldsForMyOpen(fields) {
    let newFields = [];

    fields.forEach((f) => {
        let newField = clone(f);

        if (newField.value_field_ids) newField.value_field_ids = adaptFieldsForMyOpen(newField.value_field_ids);

        newField.value_image = newField.value_image ? getBase64ImageWithHeader(newField.value_image) : "";

        newFields.push(newField);
    });

    return newFields;
}

export function adaptBlocsForOpenERP(blocs) {
    let newBlocs = [];

    blocs.forEach((b) => {
        let newBloc = clone(b);
        newBloc.create_date = undefined;
        newBloc.mobile_write_date = moment(b.mobile_write_date).utc().format("YYYY-MM-DD HH:mm:ss");
        newBloc.field_ids = adaptFieldsForOpenERP(b.field_ids);
        newBlocs.push(newBloc);
    });

    return newBlocs;
}

export function adaptFieldsForOpenERP(fields) {
    let newFields = [];

    fields.forEach((f) => {
        let newField = clone(f);
        if (newField.value_field_ids) newField.value_field_ids = adaptFieldsForOpenERP(newField.value_field_ids);

        if (newField.value_image)
            newField.value_image = newField.value_image.replace(/^data:image[\/]*[a-z]*;base64,/, ""); // eslint-disable-line

        newFields.push(newField);
    });

    return newFields;
}

export function adaptInterventionForOpenERP(intervention) {
    intervention = clone(intervention);
    intervention.date_call = moment(intervention.date_call).utc().format("YYYY-MM-DD HH:mm:ss");
    intervention.date_planned_start = moment(intervention.date_planned_start).utc().format("YYYY-MM-DD HH:mm:ss");
    intervention.delivery_customer_id = intervention.delivery_customer_id
        ? intervention.delivery_customer_id.id
        : false;
    intervention.name = undefined;
    intervention.allocation_label = undefined;
    intervention.technician_ids = intervention.technician_ids.map((t) => t.id);
    intervention.tec_manager_id = intervention.tec_manager_id.id;
    intervention.report_block_ids = adaptBlocsForOpenERP(intervention.report_block_ids);
    return intervention;
}
